import { DecisionTreeInput } from '@/components/decision-tree/components/SurveyItem/components/Question/components/DecisionTreeInput';
import { QuestionTitle } from '@/components/decision-tree/components/SurveyItem/components/Question/components/QuestionTitle';
import { Box, Grid, InlineAlert } from '@cmpsr/components';
import { FC } from 'react';
import useHeightController from './Height.controller';
import { HeightAnswer, HeightProps } from './types';

export const Height: FC<HeightProps> = ({ data, saveAnswer, defaultValue, whyWeAskModalDisclosure }) => {
  const { label, whyWeAskExplanation, feet, inches, id, tooltip, description, validationValues } = data;
  const {
    onInputFeetFn,
    onInputInchesFn,
    form,
    feetValidationOptions,
    inchesValidationOptions,
    onBlurFeetFn,
    onBlurInchesFn,
  } = useHeightController({
    id,
    validationValues,
    saveAnswer,
    defaultValue,
    feet,
    inches,
  });

  return (
    <Box width="full" maxWidth="450px">
      <QuestionTitle
        description={description}
        tooltip={tooltip}
        question={label}
        whyWeAskExplanation={whyWeAskExplanation}
        whyWeAskModalDisclosure={whyWeAskModalDisclosure}
      />
      <Grid gridTemplateColumns="1fr 1fr" gap="spacer-4" margin="auto" mt={6}>
        <Box>
          <DecisionTreeInput
            questionId={id}
            variant="outline"
            placeholder={feet.placeholder}
            defaultValue={(defaultValue as HeightAnswer)?.feet ?? undefined}
            trailingMask={feet.trailingMask}
            borderColor={
              form.formState.errors.feet?.message ? 'alert-error-default !important' : 'ui-element-outline-default'
            }
            {...form.register('feet', feetValidationOptions)}
            onInput={onInputFeetFn}
            onBlur={onBlurFeetFn}
            autoFocus
          />
          {form.formState.errors.feet?.message ? (
            <InlineAlert status="error" my="spacer-2" alignItems="flex-start">
              <InlineAlert.Icon />
              <InlineAlert.Message>{form.formState.errors.feet?.message}</InlineAlert.Message>
            </InlineAlert>
          ) : null}
        </Box>
        <Box>
          <DecisionTreeInput
            questionId={id}
            variant="outline"
            placeholder={inches.placeholder}
            defaultValue={(defaultValue as HeightAnswer)?.inches ?? undefined}
            trailingMask={inches.trailingMask}
            borderColor={
              form.formState.errors.inches?.message ? 'alert-error-default !important' : 'ui-element-outline-default'
            }
            {...form.register('inches', inchesValidationOptions)}
            onInput={onInputInchesFn}
            onBlur={onBlurInchesFn}
          />
          {form.formState.errors.inches?.message ? (
            <InlineAlert status="error" my="spacer-2" alignItems="flex-start">
              <InlineAlert.Icon />
              <InlineAlert.Message>{form.formState.errors.inches?.message}</InlineAlert.Message>
            </InlineAlert>
          ) : null}
        </Box>
      </Grid>
    </Box>
  );
};
